import GitHash from './gitHash';
export * from './gitHash';
export default GitHash;
